import { isConfigFlagEnabled } from "@/utils/configFlag";
import { useRootStore } from "@/store/root";

export function resolveDocumentsZipDownloadEnabled(raw: unknown): boolean {
  return isConfigFlagEnabled(raw, true);
}

/** Reads the resolved store flag (updated when custom config is applied). */
export function isDocumentsZipDownloadEnabled(): boolean {
  if (typeof window === "undefined") return true;

  try {
    return useRootStore().enableDocumentsZipDownload;
  } catch {
    return resolveDocumentsZipDownloadEnabled(
      window.rechnerCustomConfig?.enable_documents_zip_download,
    );
  }
}
